import { Arquivo } from './arquivo';
import { Localizacao } from './localizacao';
import { TipoDeBem } from "./tipo-de-bem";

export class CadastroBem {
  nR_BPM_BEM_PATRIMONIAL!: number;
  dS_BPM_ETIQUETA_BEM: string;
  cD_BPM_NR_UNIDADE!: Localizacao;
  dS_BPM_UNIDADE!:string;
  
  nR_BPM_TIPO_BEM_PATRIMONIAL!: TipoDeBem;
  
  dS_BPM_DESCRICAO_TIPO_BEM!: string;
  
  dS_BPM_DESCRICAO_BEM!: string;
  
  dS_BPM_NUMERO_SERIE!: string;
  
  dS_BPM_MARCA!:string;
  
  dS_BPM_MODELO!:	string;
  
  dS_BPM_PLACA!:	string;
  
  dS_BPM_OUTROS	!:string;
  
  dS_BPM_SALA!: string;
  
  cD_CDU_MATRICULA_USUARIO_CAUTELA!: number;
  
  nR_BPM_NUMERO_CONTRATO!: string;
  
  nR_BPM_NUMERO_NOTA_FISCAL!: number;
  
  vL_BPM_VALOR_AQUISICAO!: number;
  
  nR_BPM_IMOBILIZADO_TI!: number;
  
  nR_BPM_SUB_IMOBILIZADO!: number;
  
  vL_BPM_DEPRECIACAO_BEM!: number;
  
  fL_BPM_OBSERVACAO!: number;
  
  dS_BPM_OBSERVACAO!:string
  
  dT_BPM_DATA_ATUALIZACAO	!:Date;
  
  fL_BPM_ATIVO!:number;
  
  fL_BPM_DELETADO	!:number;
  
  dT_BPM_DATA_NOTA_FISCAL!:Date;
  dS_NOME:string;
  arquivos!: Arquivo;
  fL_BPM_BEM_TRAMITE:string;
  cD_CDU_MATRICULA_AUTOR:number;
}